/* eslint-disable react/no-unstable-nested-components */
/* this linter is causing false positives in this file because of how the tag
 * replacers are being created. Hopefully the problem will go away when we get
 * away from super old react-intl
 */
import { FormattedHTMLMessage } from "react-intl";

import { type VerificationService } from "../../lib/types/types";
import { makeFormattedHTMLTagReplacer } from "../../lib/utils/customTagReplacer";
import { getPrivacyPolicyUrl } from "../../lib/ProgramTheme/programThemeGetters";
import { LinkExternal } from "../LinkExternal";
import { FaqLinkComponent } from "../FaqLink/FaqLinkComponent";

export interface FooterTextProps {
  verificationService: VerificationService;
}

const FooterText = ({ verificationService }: FooterTextProps) => {
  // Disable until we have translations for the fix. https://sheerid.atlassian.net/browse/HC-798
  // const countryChoice = getSafe<string>(
  //   () => verificationService.viewModel.countryChoice.value,
  //   undefined,
  // );
  const footerClassName = "sid-footer__text";
  return (
    // The footer text block is collapsed until focused and as such is interactive.
    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
    <div className={footerClassName}>
      <FormattedHTMLMessage
        id="footerText"
        defaultMessage="By submitting the personal information above, I acknowledge that my personal information is being collected under the <privacyPolicy>privacy policy</privacyPolicy> of the business from which I am seeking a discount, and I understand that my personal information will be shared with SheerID as a processor/third-party service provider in order for SheerID to confirm my eligibility for a special offer.<aboutSheerID>More about SheerID.</aboutSheerID>"
      >
        {makeFormattedHTMLTagReplacer({
          privacyPolicy: (content) => {
            const url = getPrivacyPolicyUrl(verificationService!.programTheme);
            return url ? (
              <LinkExternal className="sid-privacy-policy sid-link" href={url}>
                {content}
              </LinkExternal>
            ) : (
              content
            );
          },
          aboutSheerID: (content) => (
            <FaqLinkComponent verificationService={verificationService} linkText={content} />
          ),
        })}
      </FormattedHTMLMessage>
      {/* Disable until we have translations for the fix. https://sheerid.atlassian.net/browse/HC-798 */}
      {/* {typeof countryChoice === "string" && countryChoice.length > 0 && countryChoice !== "US" ? (
        <>
          {" "}
          <FormattedHTMLMessage
            id="informationTransferredToUS"
            defaultMessage="Your information will be transferred to the United States and will be treated according to SheerID’s privacy policy."
          />
        </>
      ) : null} */}
    </div>
  );
};

export { FooterText };
